export interface Service {
    srcImage: string;
    title: string;
    text: string;
    number: string;
  }

export const ServicesList: Service[] = [
    {
        srcImage:'/services/1.webp',
        title:'Сервисы',
        text:'Создаем сервисы для взаимодействия с устройствами, которые делаем сами или с устройствами клиента, для их настройки и телеметрии.',
        number:'/services/number/1.webp'
    },
    {
        srcImage:'/services/5.webp',
        title:'Пром. дизайн',
        text:'Конструируем удобные в использовании устройства и улучшаем функционал существующих.',
        number:'/services/number/5.webp'
    }
    ,
    {
        srcImage:'/services/3.webp',
        title:'Электрические схемы',
        text:'Создаем электрические схемы в соответствии со стандартами и оптимизируем системы.',
        number:'/services/number/3.webp'
    },
    {
        srcImage:'/services/4.webp',
        title:'Топологии печатных плат',
        text:'Компонуем блоки с учетом их взаимного влияния. А также мы стараемся упростить монтаж и обслуживание.',
        number:'/services/number/4.webp'
    },
    {
        srcImage:'/services/2.webp',
        title:'ПО',
        text:'Пишем программное обеспечение для ПК, серверных машин, микроконтроллеров, а так же для встраиваемых систем.',
        number:'/services/number/2.webp'
    }
    ,
    {
        srcImage:'/services/6.webp',
        title:'Механика',
        text:'Разрабатываем движимые части, их взаимодействие, механизмы устройств, а также испытательные, выставочные стенды.',
        number:'/services/number/6.webp'
    },
];
